import React, { useState } from 'react';
import './Testimonials.css';
import amy from '../assets/avatar.png';
import lina from '../assets/avatar.png';
import jon from '../assets/avatar.png';
import erik from '../assets/avatar.png';


const Testimonials = () => {
  const testimonials = [
    {
      name: 'Amy Goldberg',
      role: 'Directrice des opérations chez Slack',
      feedback: 'Outil incroyable ! Cela a changé totalement ma manière de gérer mes courses.',
      stars: 5,
      image: amy,
    },
    {
      name: 'Lina Sloan',
      role: 'Rédactrice de contenu chez Uber',
      feedback: 'Une expérience d’achat impeccable ! Tout est bien organisé, les produits sont variés, et la livraison est super rapide. Je recommande sans hésiter !',
      stars: 5,
      image: lina,
    },
    {
      name: 'Jon Jandali',
      role: 'Le gestionnaire',
      feedback: 'Je n’ai jamais eu une expérience d’achat aussi fluide. Bravo pour cette plateforme intuitive et pour l’excellent rapport qualité-prix !',
      stars: 5,
      image: jon,
    },
    {
      name: 'Erik Hendrix',
      role: 'CEO @ enjoy food',
      feedback: 'Je suis stupéfait. Trinity a donné une nouvelle dimension dont j’ai toujours rêvé.',
      stars: 5,
      image: erik,
    },
  ];


  const [currentIndex, setCurrentIndex] = useState(0);


  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };


  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };


  return (
    <section className="testimonials">
      <div className="testimonials-title-container">
        <h2 className="testimonials-title">Ce que l’on pense de trinity</h2>
      </div>
      <div className="testimonials-carousel">
        {testimonials
          .slice(currentIndex, currentIndex + 3)
          .concat(
            testimonials.slice(0, Math.max(0, currentIndex + 3 - testimonials.length))
          )
          .map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">
                {'⭐'.repeat(testimonial.stars)}
              </div>
              <p className="testimonial-feedback">{testimonial.feedback}</p>
              <div className="testimonial-author">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="testimonial-image"
                />
                <div>
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-role">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="testimonials-navigation">
        <button className="arrow arrow-left" onClick={handlePrev}>
          {'<'}
        </button>
        <button className="arrow arrow-right" onClick={handleNext}>
          {'>'}
        </button>
      </div>
    </section>
  );
};


export default Testimonials;
